module.exports = __webpack_public_path__ + "img/24ne.dd04fc59.svg";